import React from 'react';
import _ from 'lodash';
import { Button, Icon } from '@scale/scaleui';
import type { Variant } from '@scale/scaleui/dist/v1/types';
import { TutorialMessageType } from './hooks/useTutorialStore';

export const TUTORIAL_MESSAGE_VARIANT_MAP: Record<TutorialMessageType, Variant> = {
  [TutorialMessageType.SUCCESS]: 'success',
  [TutorialMessageType.ERROR]: 'danger',
  [TutorialMessageType.INFO]: 'info',
};

interface AcknowledgeControlProps {
  messageType: TutorialMessageType | undefined;
  checked: boolean;
  setChecked: () => void;
}

const AcknowledgeControl: React.FC<AcknowledgeControlProps> = ({
  messageType,
  checked,
  setChecked,
}) => {
  const variant = messageType ? _.get(TUTORIAL_MESSAGE_VARIANT_MAP, messageType, 'info') : 'info';

  if (checked) {
    return (
      <Icon
        className="rounded-lg"
        icon={checked ? ['fas', 'circle-check'] : ['fas', 'message-exclamation']}
        variant={variant}
      />
    );
  }

  return (
    <Button onClick={setChecked} variant={variant}>
      Acknowledge
    </Button>
  );
};

export default AcknowledgeControl;
